import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '@/components/Button';
import sadIcon from '@/assets/sad.svg';

const PenaltyRestrictionDialog = ({
  isOpen,
  mode = 'penalty',
  onConfirm,
  onSecondary,
  onClose,
}) => {
  const { t } = useTranslation();

  const isBannedMode = mode === 'banned';

  const copy = useMemo(() => {
    if (isBannedMode) {
      return {
        title: t('penalty.dialog.banned.title'),
        description: t('penalty.dialog.banned.description'),
        confirmLabel: t('penalty.dialog.banned.confirm'),
        secondaryLabel: t('penalty.dialog.banned.secondary'),
      };
    }
    return {
      title: t('penalty.dialog.penaltyRequired.title'),
      description: t('penalty.dialog.penaltyRequired.description'),
      confirmLabel: t('penalty.dialog.penaltyRequired.confirm'),
      secondaryLabel: t('penalty.dialog.penaltyRequired.secondary'),
    };
  }, [isBannedMode, t]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="w-[360px] bg-white rounded-xl shadow-lg flex flex-col">
        <div className="px-6 pt-8 pb-6 flex flex-col items-center gap-4">
          <div className="w-12 h-12 flex items-center justify-center">
            <img src={sadIcon} alt="restriction" className="w-10 h-10" />
          </div>
          <h2 className="text-[#111111] text-lg font-bold text-center leading-[27px]">
            {copy.title}
          </h2>
          <p className="text-[#666666] text-sm text-center leading-[21px]">
            {copy.description}
          </p>
        </div>
        <div className="px-6 pb-6 flex flex-col items-center gap-3">
          {!isBannedMode && (
            <Button
              variant="danger"
              size="l"
              className="w-full"
              onClick={onConfirm}
            >
              {copy.confirmLabel}
            </Button>
          )}
          <Button
            variant="default"
            size="l"
            className="w-full"
            onClick={onSecondary ?? onClose}
          >
            {copy.secondaryLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PenaltyRestrictionDialog;
